<template>
<div class="wrapper" v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="page__card">
      <div class="page__card-title">
        <button
          class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl"
          @click="$router.go(-1)"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
            <h1>{{ $route.params.id ? res1.name_cyr : $t('add_new_hydrounits') }}</h1>
        </div>
    <div class="wp-body"> 
        <div class="uform">
            <el-form :model="res1" :rules="rules1" ref="res1" class="Form">
                <div class="input-section">
                    <el-row :gutter="30">
                        <el-col :md="8">
                            <label class="item">
                                <p>{{$t('hydrounits_name')}}</p>
                                <el-form-item prop="name_cyr">
                                    <el-input :disabled="disabled1" v-model="res1.name_cyr" :placeholder="$t('hydrounits_name')" clearable />
                                </el-form-item>
                            </label>

                            <label class="item">
                                <p>{{$t('hydrounits_organization_name')}}</p>
                                <el-form-item prop="organization_name">
                                    <el-input :disabled="disabled1" v-model="res1.organization_name" :placeholder="$t('hydrounits_organization_name')" clearable />
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_region')}}</p>
                                <el-form-item prop="region">
                                    <el-select :disabled="disabled1" v-model="res1.region" :loading="loading" class="w-full" :placeholder="$t('hydrounits_region')">
                                        <el-option v-for="item in dictionary.region" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_district')}}</p>
                                <el-form-item prop="district">
                                    <el-select :disabled="disabled1" v-model="res1.district" class="w-full" clearable :placeholder="$t('hydrounits_district')">
                                        <el-option v-for="item in current_district" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_address')}}</p>
                                <el-form-item prop="address">
                                    <el-input :disabled="disabled1" v-model="res1.address" :placeholder="$t('hydrounits_address')" clearable />
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_year_of_construction')}}</p>
                                <el-form-item prop="year_of_construction">
                                    <el-date-picker :disabled="disabled1" style="width: 100%" v-model="res1.year_of_construction" type="year" value-format="yyyy" :placeholder="$t('hydrounits_year_of_construction')">
                                    </el-date-picker>
                                </el-form-item>
                            </label>

                        </el-col>
                        <el-col :md="8">
                            <label class="item">
                                <p> {{$t('water_base_buildingseismicity')}} </p>
                                <el-form-item prop="buildingseismicity">
                                    <el-select :disabled="disabled1" class="w-full" v-model="res1.buildingseismicity" clearable  :placeholder="$t('finalconclusion')" >
                                        <el-option v-for="item in dictionary.buildingseismicity" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_date_of_accept')}}</p>
                                <el-form-item prop="date_of_accept">
                                    <el-date-picker :disabled="disabled1" style="width: 100%" v-model="res1.date_of_accept" value-format="dd.MM.yyyy" format="dd.MM.yyyy" :placeholder="$t('hydrounits_date_of_accept')">
                                    </el-date-picker>
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_water_source')}}</p>
                                <el-select :disabled="disabled1" v-model="res1.water_source" class="w-full" clearable :placeholder="$t('hydrounits_water_source')">
                                    <el-option v-for="item in dictionary.watersource" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                    </el-option>
                                </el-select>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_reservoir_class')}} </p>
                                <el-form-item prop="reservoir_class">
                                    <el-select :disabled="disabled1" v-model="res1.reservoir_class" class="w-full" clearable :placeholder="$t('hydrounits_reservoir_class')">
                                        <el-option v-for="item in dictionary.reservoirclass" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p> {{$t('water_base_earthquake_tolerance')}} </p>

                                <el-form-item prop="earthquake_tolerance">
                                    <el-input :disabled="disabled1" v-model="res1.earthquake_tolerance" :placeholder="$t('water_base_earthquake_tolerance')" clearable />
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_hydro_units_type')}} </p>
                                <el-form-item prop="hydro_units_type">
                                    <el-select :disabled="disabled1" v-model="res1.hydro_units_type" class="w-full" clearable :placeholder="$t('hydrounits_hydro_units_type')">
                                        <el-option v-for="item in dictionary.reservoirtype" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>

                        </el-col>
                        <el-col :md="8">
                            <!-- Сув омборининг лойиҳа бўйича асосий кўрсаткичлари-->
                            <p class="indicator ">{{$t('hydrounits_main_indicator')}}:</p>
                            <label class="item">
                                <p>{{$t('max_height')}}</p>
                                <div class="flex">
                                    <el-form-item class="flex-auto w-full" prop="max_height.value">
                                        <el-input type="number" :disabled="disabled1" :placeholder="$t('max_height')" v-model="res1.max_height.value" clearable />
                                    </el-form-item>
                                    <el-form-item prop="max_height.unit">
                                        <el-select :disabled="disabled1" v-model="res1.max_height.unit" class="ml-3" clearable>
                                            <el-option v-for="item in units.unit_1" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </label>
                            <label class="item">
                                <p>{{$t('lengths')}} </p>
                                <div class="flex">
                                    <el-form-item class="flex-auto w-full" prop="length.value">
                                        <el-input type="number" :disabled="disabled1" v-model="res1.length.value" :placeholder="$t('lengths') " clearable />
                                    </el-form-item>
                                    <el-form-item prop="length.unit">
                                        <el-select :disabled="disabled1" v-model="res1.length.unit" class="ml-3" clearable>
                                            <el-option v-for="item in units.unit_1" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_number_of_gates')}}</p>
                                <el-form-item prop="number_of_gates">
                                    <el-input :disabled="disabled1" v-model="res1.number_of_gates" :placeholder="$t('hydrounits_number_of_gates')" clearable />
                                </el-form-item>
                            </label>
                            <label class="item">
                                <p>{{$t('hydrounits_gate_construction') }}</p>
                                <el-form-item prop="gate_construction">
                                    <el-select :disabled="disabled1" v-model="res1.gate_construction" class="w-full" clearable :placeholder="$t('hydrounits_gate_construction')">
                                        <el-option v-for="item in dictionary.gate_construction" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <!-- ---------------------- -->
                            <label class="item">
                                <p> {{$t('finalconclusion')}} </p>
                                <el-form-item prop="finalconclusion">
                                    <el-select :disabled="disabled1" v-model="res1.finalconclusion" class="w-full" clearable  :placeholder="$t('finalconclusion')" >
                                        <el-option v-for="item in dictionary.finalconclusion" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                            <!-- <p class="indicator mt-3">Сув омборининг 2021 ойидаги ҳолатига</p>
                            <label class="item">
                                <p>Mаксимал сув ҳажми</p>
                                <div class="flex">
                                    <el-form-item class="flex-auto w-full" prop="floors_height.value">
                                        <el-input type="number" :disabled="disabled1" placeholder="Mаксимал сув ҳажми" v-model="res1.date_of_accept" clearable />
                                    </el-form-item>
                                    <el-form-item prop="floors_height.unit">
                                        <el-select :disabled="disabled1" v-model="res1.max_water_volume.unit" class="ml-3" clearable>
                                            <el-option v-for="item in units.unit_4" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </label>
                            <label class="item">
                                <p>Hормал сув  ҳажми</p>
                                <div class="flex">
                                    <el-form-item class="flex-auto w-full" prop="floors_height.value">
                                        <el-input type="number" :disabled="disabled1" placeholder="Hормал сув  ҳажми" v-model="res1.date_of_accept" clearable />
                                    </el-form-item>
                                    <el-form-item prop="floors_height.unit">
                                        <el-select :disabled="disabled1" v-model="res1.max_water_volume.unit" class="ml-3" clearable>
                                            <el-option v-for="item in units.unit_4" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </label>
                            <label class="item">
                                <p>Ўлик сув ҳажми</p>
                                <div class="flex">
                                    <el-form-item class="flex-auto w-full" prop="floors_height.value">
                                        <el-input type="number" placeholder="Ўлик сув ҳажми" :disabled="disabled1" v-model="res1.date_of_accept" clearable />
                                    </el-form-item>
                                    <el-form-item prop="floors_height.unit">
                                        <el-select :disabled="disabled1" v-model="res1.max_water_volume.unit" class="ml-3" clearable>
                                            <el-option v-for="item in units.unit_4" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </label> -->

                            <div class="actions mt-10">
                                <div class=" flex justify-end w-full" v-if="role !== 'admin' &&  !disabled1">
                                    <!-- <el-button v-if="res1.id" class="primary-btn"><i class="el-icon-edit mr-1"></i>Ўзгартириш</el-button> -->
                                    <div>
                                        <el-button @click.native="save1()" class="primary-btn " style="width:150px"><i class="el-icon-document-checked mr-1"></i> {{$t('save')}}</el-button>
                                    </div>

                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>
    </div>
    
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            disabled1: false,
            disabled2: false,
            isCreated2: false,
            loading: false,
            activeNames: "1",
            current_district: {},
            obj: {},
            isCreated: false,
            res1: {
                name_cyr: '',
                address: '',
                year_of_construction: '',
                date_of_accept: '',
                organization_name: '',
                user_organization_name: '',
                earthquake_tolerance: '',
                region: '',
                district: "",
                water_source: '',
                reservoir_class: '',
                hydro_units_type: '',
                buildingseismicity:'',
                max_height: {
                    value: null,
                    unit: 1
                },
                length: {
                    value: null,
                    unit: 1
                },
                number_of_gates: '',
                gate_construction: '',
                finalconclusion: ''
            },
            rules1: {

                name_cyr: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                address: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                year_of_construction: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                date_of_accept: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                organization_name: '',
                user_organization_name: '',
                earthquake_tolerance: '',
                region: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                district: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                water_source: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                reservoir_class: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                hydro_units_type: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                buildingseismicity:{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                max_height: {
                    value: {
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },
                    unit: {
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    }
                },
                length: {
                    value: {
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },
                    unit: {
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },
                },
                number_of_gates: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                gate_construction: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                finalconclusion: {
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },

            },
        }
    },
    computed: {
        dictionary() {
            return this.$store.state.dictionary;
        },
        units() {
            return this.$store.state.units;
        },
        role() {
             return this.$store.state.role;
        },
        page() {
            return this.$route.query.id || '';
        },

    },
    watch: {
        'res1.region': function () {
            this.current_district = [];

            this.loading = true;
            axios.get(`/dictionary/district/?region=${this.res1.region}`)
                .then((response) => {
                    this.current_district = response.data;
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    },
    mounted() { 
        if (this.$route.params.id) {
            this.disabled1 = this.$route.params.edit == '1' ? true : false
            if (this.role === 'admin' || this.role === 'supervisor') {
                this.disabled1 = true;
            }
            this.__GET()
        }

    },
    methods: {
        __GET() {
            if (this.$route.params.id) {
                this.loading = true;
                axios.get(`/reservoir/hydrounits/${this.$route.params.id}`)
                    .then((response) => {
                        response.data.year_of_construction = String(response.data.year_of_construction)
                        this.res1 = response.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            } else {

            }
        },
        save1() {
            this.$refs.res1.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    if (!this.$route.params.id) {
                        axios.post('/reservoir/hydrounits/', this.res1)
                            .then((response) => {
                                axios.post(`/reservoir/hydrounits/${response.data.id}/generate/`)
                                    .then(res => { 
                                        this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link
                                    })
                                this.$swal.fire({
                                    icon: 'success',
                                    title:this.$t('sucsess_save'),
                                    timer: 3000
                                })
                                this.$router.push({
                                    path: '/reservoir/hydrounits'
                                })
                            })
                            .catch(error => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_create'),
                                    timer: 3000
                                })
                            })
                            .finally(() => {
                                this.loading = false;
                            })
                    } else {
                        axios.put(`/reservoir/hydrounits/${this.$route.params.id}/`, this.res1)
                            .then((response) => {
                               axios.post(`/reservoir/hydrounits/${response.data.id}/generate/`)
                                    .then(res => { 
                                        this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link

                                    }) 
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('data_saved'),
                                    timer: 3000
                                })
                                this.$router.push({
                                    path: '/reservoir/hydrounits'
                                })
                            })
                            .catch(error => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_save'),
                                    timer: 3000
                                })
                            })
                            .finally(() => {
                                this.loading = false;
                            })
                    }
                }

            })
        },
        regionChanged() {
            this.current_district = [];
            this.spec1.district = [];
            this.getDistrict();
        },
        getDistrict() {
            this.loading = true;
            axios
                .get(`/dictionary/district/?region=${this.res1.region}`)
                .then((response) => {
                    this.current_district = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.indicator {
    font-weight: 500;
    font-size: 20px;
    padding: 15px 0;
    border-bottom: 2px solid #3730A3;
}

.el-collapse-item__header {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 37px;
    display: flex;
    align-items: center;
    color: #3730A3 !important;
    padding: 15px 0;
    border-bottom: none;
}

.build-tab {
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;

    li {
        cursor: pointer;
        width: 400px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: solid 1px #d4d4d4;
        font-size: 17px;
        line-height: 24px;
        color: #3730A3;
        position: relative;
        user-select: none;

        &.active {
            border-bottom: solid 3px #3730A3;
        }
    }
}

.uform .Form {
    .el-form-item__content {
        margin-left: 0 !important;
    }
}

.uform .el-form-item {
    margin-bottom: 0 !important;
}

</style>
